import { useEffect, useState } from "react";
import MDBox from "common/components/MD/MDBox";
import { Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fab } from "@mui/material";
import MDTypography from "common/components/MD/MDTypography";
import MDInput from "common/components/MD/MDInput";
import AuthService from "services/API/Auth/AuthService";
import EPService from 'services/API/expo_partecipazioni/ExpoPartecipazioniService';
import base64ToArrayBuffer from "common/script/base64ToArrayBuffer";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import MDButton from "common/components/MD/MDButton";
//validazione lato client
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { useNavigate } from "react-router-dom";
import ReactHookFormCheckBox from "common/components/mycomponents/ReactHookFormCheckBox";

function ExpoContrattoEdit({ id_contratto ,id_partecipazione}) {
    
    const [prop, setProp] = useState({

        id_partecipazione: 0,
        id_utente: AuthService.getCurrentUser().id,

    });
    const [file_rx, setFile_rx] = useState();
 const navigate = useNavigate();


    useEffect(() => {
        if (id_contratto != null && id_contratto !== 0) {
            //console.log("carico il componente contratto edit id_contratto=" + id_contratto);
            seleziona_soggetto();
        } else {
            console.log("soggetto nullo");
        }
    }, [id_contratto]);

    async function seleziona_soggetto() {
      //  console.log("seleziono i id_contratto :" + id_contratto);
        if (id_contratto !== 0) {
            const response = await EPService.seleziona_contratto(id_contratto);
            response.errors ? console.log(response.errors) : retrive(response.data);
        }else{
const response = await EPService.seleziona_contratto2(id_partecipazione);
            response.errors ? console.log(response.errors) : retrive(response.data);

        }
    }




    function retrive(data) {
       
        setProp({
            id_contratto: id_contratto,
            id_partecipazione: data.id_partecipazione,
            id_utente: data.id_utente,
            nome_pdf_contratto: data.nome_pdf_contratto,
            data_contratto: data.data_contratto,
            contratto_protocollato: data.contratto_protocollato
        });
        setFile_rx(data.nome_pdf_contratto);
          setValue("contratto_protocollato",data.contratto_protocollato);

    }


    const visualizza_pdf = () => {
        if (id_contratto !== 0) {
            let filename = prop.nome_pdf_contratto;

            EPService.download_pdf_contratto(prop.id_partecipazione)
                .then(response => {

                    return response.data;
                })
                .then(blob => {

                    var arrrayBuffer = base64ToArrayBuffer(blob); //data is the base64 encoded string
                    var blobb = new Blob([arrrayBuffer], { type: "application/pdf" });
                    var url = URL.createObjectURL(blobb);
                    var a = document.createElement('a');
                    a.href = url;
                    a.target = "_blank";
                    a.download = filename;
                    document.body.appendChild(a); // append the element to the dom
                    a.click();
                    a.remove(); // afterwards, remove the element  
                })
                .catch(error => {
                    console.error(error);
                });


        }
    };


    const [open2, setOpen2] = useState(false);
    const [confirm2, setConfirm2] = useState(false);
    function handleClose2() {
        setOpen2(false);
    }

    function handleConfirm2() {
        setConfirm2(true);
        setOpen2(false);
        elimina_pdf();
    }


    const handleOpen2 = () => {
      
        setOpen2(true);
    }

    function elimina_pdf() {

        EPService.elimina_pdf_contratto(prop.id_contratto)
            .then(response => {
                handleResponse(response, 'DELETED');
               setFile_rx(null);
            
            })
            .catch(errore => {
                handleError(errore);
            });


    }

    /* ----------------------------VALIDAZIONE E SALVATAGGIO----------------------------------------------------------------------- */


    const validationSchema = Yup.object().shape({
        pdf_contratto: Yup.mixed()
            .required("Devi caricare un file")
            .test("fileSize", "Il file è troppo grande o non c'è!", (file) => {
                //if u want to allow only certain file sizes
                return file && file[0] && file[0].size <= 2000000;
            })

    });



    /* ----------------------------SALVATAGGIO E REGISTRAZIONE------------------------------------------------- */


    const {
        register, //register inputs
        reset, setValue, control,
        handleSubmit,//handle form submit
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });




    const [error, setError] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const [ok, setOk] = useState(null);
    const [okMessage, setOkMessage] = useState(null);



    const inserisci_pp = (formData) => {

         setError(null);

        var data = {
            idPartecipazione:id_partecipazione,
            id_utente: AuthService.getCurrentUser().id,
            manifestazione: prop.manifestazione,
            pdf_contratto: formData.pdf_contratto,
       
        };

        EPService.invia_contratto(id_partecipazione, data)
            .then(response => {
                handleResponse(response, 'SENT');            
                setFile_rx(formData.pdf_contratto);
                id_contratto=0;
                seleziona_soggetto();
             })
            .catch(errore => {
                handleError(errore);
            });



    }


    function handleResponse(response, op) {
        //  console.log(response.data);
        setOk("OK");
        setOkMessage("Operazione " + op + " completata con successo!");
    }


    function handleError(error) {
        setError(error);
        console.log("ERRORE" + error);
        console.log(error.code);

        if (error.response) {
            console.log("ERROR:RESPONSE" + error.response.data);
            setErrorMessage(error.response.data);

        } else if (error.request) {
            console.log("EEROR:REQUEST" + error.request);
            setErrorMessage(error.request);
        } else {
            console.log('Error', error.message);
            setErrorMessage(error.message);
        }

    }


   
    return (

        <MDBox>

            <Dialog open={open2} onClose={handleClose2} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                <DialogTitle id="alert-dialog-title">
                    Eliminare il PDF ?
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Sei sicuro di voler eliminare il pdf ricevuto ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={handleClose2}>No</MDButton>
                    <MDButton onClick={handleConfirm2} autoFocus>
                        SI
                    </MDButton>
                </DialogActions>
            </Dialog>



            <MDBox pt={1} pb={3} px={3} component="form" role="form">

                {file_rx &&
                    <MDBox mb={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 2fr 2fr' }}>
                        <MDTypography variant="h6">Nome file Ricevuto : {prop.nome_pdf_contratto}</MDTypography>
                        <Fab variant="extended" color="light" size="medium" onClick={visualizza_pdf}>
                            <MDTypography variant="h7" fontWeight="regular" color="success">  <VisibilityIcon sx={{ mr: 1 }} color="success" />Vedi il PDF Caricato</MDTypography>
                        </Fab>
               
                            <Fab variant="extended" color="light" size="medium" onClick={handleOpen2}>
                                <MDTypography variant="h7" fontWeight="regular" color="success"> <DeleteForeverIcon sx={{ mr: 1 }} />Elimina il PDF Caricato</MDTypography>
                            </Fab>

                    </MDBox>}


                {ok !== null &&
                    <Alert color="success" mb={3}><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{okMessage}</Alert>}

                {error !== null &&
                    <Alert color="error" mb={3}><ErrorOutlineOutlinedIcon fontSize="small" />&nbsp;{errorMessage}</Alert>

                }

                {!file_rx &&
                    <MDBox my={2} sx={{ display: 'grid', gap: 1, gridTemplateColumns: '3fr 1fr ' }}>

                        <MDInput
                            type="file"
                            label="Contratto" fullWidth required
                            autocomplete="off"  {...register('pdf_contratto')}
                            name="pdf_contratto" InputLabelProps={{ shrink: true }}

                        />
                        <Fab variant="extended" color="light" size="medium" onClick={handleSubmit(inserisci_pp)}>
                            <MDTypography variant="h7" fontWeight="regular" color="success"> <FileUploadIcon sx={{ mr: 1 }} />Salva</MDTypography>
                        </Fab>
                        {
                            errors.pdf_contratto ? <span style={{ color: 'red', fontSize: '12px' }}>{errors.pdf_contratto?.message}</span> : ''
                        }
                        
                    </MDBox>

                }

            </MDBox>
           
            
            
            </MDBox>

    );

}

export default ExpoContrattoEdit;